import { Form } from "react-bootstrap";

const Select = (props) => {
  const { className, name, value, checked, onBlur, onChange, onFocus, meta, field, children, ...attributes } = props || {};
  const { label, ariaLabel } = field || {};

  return <div className={"row " + className}>
    <Form.Label htmlFor={name} className="col-6 col-form-label col-form-label-sm" >{label}</Form.Label>
    <div className="col-6">
      <Form.Select
        {...attributes}
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        aria-label={ariaLabel}
        size="sm"
      >
        {children}
      </Form.Select>
    </div>
  </div>;
};
export default Select;
